module.exports = __webpack_public_path__ + "fonts/Lato-LightItalic.7865ec9d.ttf";